import { createContext } from "react";
import { IContextWorkTime } from "../types/workTime.interface";

const WorkTimeScreen = createContext<IContextWorkTime>({});

export default WorkTimeScreen;
